/** 险种页 + 行业页：购买哪家好 / 怎么买（各 +1 条，共 +2 条/页） */
export default {
  directorsOfficers: [
    {
      q: '董责险购买哪家好？',
      a: '董责险（D&O）保障董事、监事及高级管理人员因公司治理、信息披露、股东诉讼等引发的个人责任与辩护费用，是上市公司、拟上市企业及有外部董事企业的核心保障。选择经纪机构时，应重点考察 D&O 专业经验、全球保险人网络及跨境监管理解能力。上海耀达（SWI）成立于2009年，D&O 团队平均从业超10年，累计安排保费超1000万美元，对接30+全球保险人，服务200+机构客户，提供方案设计、比价投保与理赔协助。'
    },
    {
      q: '董责险怎么买？',
      a: '购买董责险通常需：评估公司治理与诉讼风险；准备公司资料、财报及历史索赔记录；明确 Side A/B/C 保障需求与限额；通过保险经纪对接多家保险人比价并确认条款后出单。上海耀达（SWI）可协助从风险梳理、材料准备、市场询报价到续保管理的全流程，帮助企业获得匹配治理结构与融资阶段的 D&O 方案。'
    }
  ],
  mergersAcquisitions: [
    {
      q: '并购W&I保险购买哪家好？',
      a: '并购保证及补偿保险（W&I）用于转移并购交易中陈述与保证违约风险，可替代或减少 escrow 安排、加速交割，常见于跨境并购与私募基金退出交易。选择服务商应关注交易保险经验、保单架构设计能力及交易后索赔支持。上海耀达（SWI）专注并购交易风险解决方案，提供目标公司分析、风险识别、买方/卖方保单设计及全球市场接入，助力客户争取最优条款与费率。'
    },
    {
      q: '并购W&I保险怎么买？',
      a: '购买 W&I 保险一般需在签署 SPA 前后启动：完成尽职调查摘要、梳理保证条款争议点；确定买方或卖方保单结构及责任限额；提交交易资料与市场询报价；在交割前或交割同时绑定保单。耀达可协助评估交易是否适合 W&I、设计可负担的保单架构并对接全球 W&I 市场完成出单。'
    }
  ],
  cyberSecurity: [
    {
      q: '网络安全保险购买哪家好？',
      a: '网络安全保险覆盖数据泄露响应、业务中断、网络勒索及第三方隐私与媒体责任，是企业数字风险管理体系的重要补充。选择经纪时应关注网络险专业经验、风险评估工具及事件响应资源对接能力。上海耀达（SWI）依托 AI 风险评估能力及科技/金融客户服务经验，为企业识别网络敞口、设计定制化保障，并对接全球专业网络险市场。'
    },
    {
      q: '网络安全保险怎么买？',
      a: '购买网络保险通常需：完成网络安全问卷或风险评估；明确第一方/第三方保障范围与限额；通过保险经纪向多家保险人询报价；审阅除外责任与通知义务后出单。耀达提供从风险诊断、方案设计、市场比价到理赔协调的全流程协助，帮助企业匹配实际网络暴露的保单结构。'
    }
  ],
  propertyCasualty: [
    {
      q: '财产与意外险购买哪家好？',
      a: '财产与意外险包括商业财产、综合责任（CGL）、产品责任、商业车险及工伤赔偿等，保障企业固定资产、运营责任与第三者索赔。选择经纪应关注行业定制能力、跨境安排经验及理赔支持。上海耀达（SWI）按企业发展阶段与行业特点设计方案，支持跨境 master policy 架构，提供从资产盘点、方案比价到理赔协助的一站式服务。'
    },
    {
      q: '财产与意外险怎么买？',
      a: '购买财产与意外险需：梳理资产清单与运营/第三者责任风险；结合行业特点确定保障组合与限额；通过保险经纪对接市场比价；确认免赔额、除外条款后投保。耀达协助企业完成风险评估、方案设计与续保优化，并可与董责险、网络险等组合配置实现一揽子风险管理。'
    }
  ],
  employeeBenefits: [
    {
      q: '员工福利保险购买哪家好？',
      a: '员工福利保险涵盖团体医疗、人寿、意外、重疾及养老等，关系企业人才吸引与留存。选择经纪应关注方案设计能力、成本管控经验及跨国福利统筹能力。上海耀达（SWI）提供企业需求评估、员工调研、方案比价、动态优化及理赔协助，在上海、香港、美国均可协助全球员工福利设计。'
    },
    {
      q: '员工福利保险怎么买？',
      a: '购买员工福利保险一般流程为：明确企业预算与员工需求→开展调研与方案设计→多家保险人比价→投保参保→年度回顾与优化。耀达可协助设计分层保障（基础+自选升级），并通过赔付率分析与市场比价控制续保成本。'
    }
  ],
  globalClients: [
    {
      q: '跨境保险购买哪家好？',
      a: '跨境保险需兼顾各国本地合规与全球总部战略一致性，涵盖财产、责任、董责、网络及雇员保障等多险种协调。选择经纪应重点考察多国牌照布局、本地洞察与全球统筹能力。上海耀达（SWI）在上海、香港、美国持牌设点，对接200+保险人，帮助出海及外资客户设计覆盖多国的保险架构与 master policy 方案。'
    },
    {
      q: '跨境保险怎么买？',
      a: '安排跨境保险通常需：梳理各国运营实体与监管要求；在本地持牌机构安排合规保单；通过全球主保单或协调机制统一保障标准；持续随业务扩张调整架构。耀达可协助完成多国暴露分析、本地与全球方案衔接及集中管理与报告支持。'
    }
  ],
  privateEquity: [
    {
      q: '私募股权基金保险购买哪家好？',
      a: '私募股权/风险投资基金需配置 D&O、外部董事责任、专业责任及犯罪险等，覆盖募资、投资、管理与退出全周期风险。选择经纪应考察 PE/VC 行业深耕程度与基金结构理解能力。上海耀达（SWI）服务众多美元及人民币基金，熟悉 GP/LP 保障边界设计，可对接全球保险市场争取最优条款。'
    },
    {
      q: '私募股权基金保险怎么买？',
      a: '购买 PE/VC 基金保险需根据基金规模、投资策略、被投组合、退出计划及历史索赔定制方案，明确 GP、管理人及外部董事的被保险主体。耀达协助评估各阶段风险、准备募资与尽调相关材料，并完成市场询报价与保单绑定。'
    }
  ],
  lifeScience: [
    {
      q: '生命科学行业保险购买哪家好？',
      a: '生命科学企业需覆盖临床试验、产品责任、D&O、财产及冷链运输等从研发到商业化的全链条风险。选择经纪应关注生物医药行业经验与监管合规理解。上海耀达（SWI）服务制药、器械、Biotech 及保健品企业，参与 BiG IMPACT 等行业活动，提供临床前至商业化全周期定制保险方案。'
    },
    {
      q: '生命科学行业保险怎么买？',
      a: '购买生命科学保险需按研发阶段配置：临床前可安排一般责任、财产及早期 D&O；进入临床后增加临床试验责任险；商业化阶段强化产品责任与召回保障。耀达协助企业分阶段完善保障架构，并对接符合监管要求的市场产品。'
    }
  ],
  financialInstitutions: [
    {
      q: '金融机构保险购买哪家好？',
      a: '金融机构面临监管合规、证券集体诉讼、数据安全及运营资产等多重风险，需组合配置 D&O、专业责任、网络险及犯罪险等。选择经纪应关注金融行业专业度与高额限额安排经验。上海耀达（SWI）专注金融与高管责任风险，服务银行、证券、FinTech 及区域/跨国金融客户，提供定制化一揽子方案。'
    },
    {
      q: '金融机构保险怎么买？',
      a: '购买金融机构保险需：识别治理、专业服务、网络及运营等核心暴露；确定 D&O/PI 限额与监管相关除外审阅重点；通过经纪对接专业市场比价；结合内控与披露要求持续优化。耀达协助设计符合金融行业特点的保障组合并完成询报价与续保管理。'
    }
  ],
  realEstateConstructions: [
    {
      q: '建筑工程保险购买哪家好？',
      a: '建筑工程保险包括建工一切险、安装工程险、履约保证、物业责任及环境责任等，覆盖开发、施工、运营全周期。选择经纪应关注工程背景顾问、大型项目再保险资源及理赔响应。上海耀达（SWI）配备建筑工程背景团队，整合全球再保险应对复杂项目，提供从项目评估到理赔协助的全流程服务。'
    },
    {
      q: '建筑工程保险怎么买？',
      a: '购买建筑工程保险需根据项目阶段、工程造价、工期、施工方式及合同要求定制方案，施工前尽早安排工程险，运营期转换财产与责任保障。耀达协助完成风险识别、方案设计、市场比价及与总部保单的跨境协调。'
    }
  ],
  automotiveInfrastructure: [
    {
      q: '汽车与基础设施保险购买哪家好？',
      a: '汽车与基建领域面临电动化、智能化带来的电池、充电设施、自动驾驶及网络责任等新风险，基建项目还需财产、工程与融资相关保障。选择经纪应关注跨学科团队与新兴风险产品对接能力。上海耀达（SWI）培养兼具保险与汽车新技术背景的团队，主动对接 OEM 与数据平台，开发匹配新生态的保障方案。'
    },
    {
      q: '汽车与基础设施保险怎么买？',
      a: '购买相关保险需：识别 OEM、供应链或基建项目的具体暴露（产品责任、网络、工程险等）；结合合同责任分配设计组合方案；通过经纪对接支持 UBI、绿色基建等专业产品的市场。耀达协助评估风险、比价选方案并支持续保与理赔。'
    }
  ],
  manufacturingTechnology: [
    {
      q: '制造与科技行业保险购买哪家好？',
      a: '制造与科技企业需配置财产、产品责任、供应链中断、网络及 D&O 等，覆盖生产、销售、研发与融资各阶段风险。选择经纪应关注行业定制能力与出口/multinational 安排经验。上海耀达（SWI）为制造与科技企业提供全生命周期方案，协助出口企业安排多国产品责任及供应链保障。'
    },
    {
      q: '制造与科技行业保险怎么买？',
      a: '购买制造与科技保险需：梳理资产、产品责任、供应链及 IP/数据等暴露；按企业发展阶段组合财产、责任、BI 及 D&O；通过经纪比价并审阅除外条款。耀达协助完成风险盘点、限额设计与跨境保障协调。'
    }
  ],
  foodBeverage: [
    {
      q: '食品与饮料行业保险购买哪家好？',
      a: '食品与饮料企业面临产品责任、食品安全召回、冷链中断及餐饮连锁运营等风险，需覆盖生产、流通到终端全链条。选择经纪应理解食安与召回场景的专业处理能力。上海耀达（SWI）服务食品生产、流通及餐饮全链条客户，提供产品责任、召回及供应链整合方案。'
    },
    {
      q: '食品与饮料行业保险怎么买？',
      a: '购买食品行业保险需：评估产品类型、销售渠道与召回暴露；配置产品责任及可选召回附加保障；连锁企业可采用主保单框架统一各门店安排。耀达协助进出口食品企业设计跨境责任与货运保障并完成市场比价。'
    }
  ],
  energyPower: [
    {
      q: '能源与电力行业保险购买哪家好？',
      a: '能源与电力项目涉及财产、工程、环境责任、营业中断及 ESG 相关治理风险，新能源项目还需关注设备性能与并网风险。选择经纪应考察大型复杂项目经验与全球再保险资源。上海耀达（SWI）服务传统及新能源项目，整合再保险资源，提供从风险评估到理赔协助的专业服务。'
    },
    {
      q: '能源与电力行业保险怎么买？',
      a: '购买能源项目保险需：按建设/运营阶段分阶段安排工程险与财产险；对齐融资协议中的技术/性能条款；配置环境责任及 D&O 等治理相关保障。耀达协助设计全周期保障架构并完成高限额项目的 market placement。'
    }
  ],
  sportsEntertainmentEvents: [
    {
      q: '活动保险购买哪家好？',
      a: '体育、娱乐及大型活动需配置取消/延期险、主办方责任险、财产险及参与者意外等，覆盖筹备至执行各阶段。选择经纪应关注活动行业经验与紧急排期能力。上海耀达（SWI）为主办方、制作方、艺人及相关主体提供活动风险管理方案，可对接专业活动保险市场。'
    },
    {
      q: '活动保险怎么买？',
      a: '购买活动保险需：根据活动规模、类型、地点、日期及合同要求尽早定制方案；明确取消险触发条件与责任限额；活动开始前完成投保。耀达协助评估天气、艺人、场地等关键风险并完成询报价与出单。'
    }
  ]
}
